module.exports = __webpack_public_path__ + "static/media/discountact.eaa0a8ea.svg";